import { render, staticRenderFns } from "./submission-panel-supporter.vue?vue&type=template&id=7ef2aab2&scoped=true&"
import script from "./submission-panel-supporter.vue?vue&type=script&lang=ts&"
export * from "./submission-panel-supporter.vue?vue&type=script&lang=ts&"
import style0 from "./submission-panel-supporter.vue?vue&type=style&index=0&id=7ef2aab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef2aab2",
  null
  
)

export default component.exports